import styled from 'styled-components';

export const SectionHeading = styled.h2`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  font-size: 1.25rem;
  font-weight: ${Styles.fontWeight.normal};
  letter-spacing: 'normal';
  margin-block-start: 0;
  margin-block-end: 0.625rem;
  margin-inline: 0;
  text-transform: ${Styles.textTransform.headlines};
`;
